import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from './../components/sidebar';
import { Container, Row, Col, Card, Table, ProgressBar, Spinner } from 'react-bootstrap';
import { FaUsers, FaCoins, FaEnvelope, FaChartBar, FaShoppingCart } from 'react-icons/fa';
import Button from "react-bootstrap/Button";
import * as XLSX from 'xlsx';

const Reportesuser = () => {
  const [dataReport, setDataReport] = useState({
    loading: true,
    error: null,
    data: {
      totals: {
        referidos: 0,
        ganancias: 0,
        ganancias25: 0, // Nuevo campo para el 25%
        invitaciones: 0,
        efectivas: 0,
        compradores: 0,
        totalVentas: 0
      },
      invitados: []
    }
  });

  const [users, setUsers] = useState({});
  const [wooOrders, setWooOrders] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser');
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  const fetchWooCommerceOrders = async () => {
    try {
      const response = await axios.get('https://mrcirp.com/wp-json/wc/v3/pedidos-publicos/?status=completed');
      return response.data;
    } catch (error) {
      console.error('Error fetching WooCommerce orders:', error);
      return [];
    }
  };

  const reportesGetUser = async (userId) => {
    try {
      setDataReport(prev => ({...prev, loading: true, error: null}));
      
      const response = await axios.get(`https://api.mrcirp.com/public/reportes/${users.id}`);
      const userData = response.data;
      
      const orders = await fetchWooCommerceOrders();
      setWooOrders(orders);

      const invitadosConCompras = userData.map((item, index) => {
        const compras = orders.filter(order => order.cliente_email === item.correo);
        const totalComprado = compras.reduce((sum, order) => sum + parseFloat(order.total), 0);
        
        return {
          id: item.id || index + 1,
          nombre: item.nombre || 'Sin nombre',
          email: item.correo || 'Sin correo',
          programa: item.producto || 'Sin programa',
          amigo_nombre: item.amigo_nombre || 'No especificado',
          amigo_email: item.amigo_email || 'No especificado',
          estado: item.estado || 'desconocido',
          fecha: item.fecha || 'No especificada',
          haComprado: compras.length > 0,
          compras: compras,
          totalComprado: totalComprado
        };
      });

      const compradores = invitadosConCompras.filter(i => i.haComprado).length;
      const totalVentas = invitadosConCompras.reduce((sum, item) => sum + item.totalComprado, 0);
      const ganancias25 = totalVentas * 0.25; // Calculamos el 25% del total de ventas

      setDataReport({
        loading: false,
        error: null,
        data: {
          totals: {
            referidos: userData.length,
            ganancias: userData.reduce((sum, item) => sum + (item.ganancia || 0), 0),
            ganancias25: ganancias25,
            invitaciones: userData.length,
            efectivas: userData.filter(item => item.estado === 'activo').length,
            compradores: compradores,
            totalVentas: totalVentas
          },
          invitados: invitadosConCompras
        }
      });

    } catch (error) {
      console.error('Error fetching user reports:', error);
      setDataReport({
        loading: false,
        error: 'Error al cargar los reportes',
        data: {
          totals: {
            referidos: 0,
            ganancias: 0,
            ganancias25: 0,
            invitaciones: 0,
            efectivas: 0,
            compradores: 0,
            totalVentas: 0
          },
          invitados: []
        }
      });
    }
  };

  useEffect(() => {
    if (users.id) {
      reportesGetUser(users.id);
    }
  }, [users.id]);

  const efectividad = dataReport.data.totals.invitaciones > 0 
    ? (dataReport.data.totals.efectivas / dataReport.data.totals.invitaciones) * 100 
    : 0;

  const conversion = dataReport.data.totals.invitaciones > 0
    ? (dataReport.data.totals.compradores / dataReport.data.totals.invitaciones) * 100
    : 0;

  const exportToExcel = () => {
    const excelData = dataReport.data.invitados.map(invitado => ({
      '#': invitado.id,
      'Nombre': invitado.nombre,
      'Email': invitado.email,
      'Programa': invitado.programa,
      'Amigo Referido': invitado.amigo_nombre,
      'Fecha Registro': invitado.fecha,
      'Estado': invitado.estado === 'activo' ? 'Activo' : 'Inactivo',
      'Ha comprado': invitado.haComprado ? 'Sí' : 'No',
      'Total comprado': invitado.haComprado ? `$${invitado.totalComprado.toFixed(2)}` : '$0.00',
      'N° Compras': invitado.compras.length,
      '25% Ganancias': invitado.haComprado ? `$${(invitado.totalComprado * 0.25).toFixed(2)}` : '$0.00'
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Mis Invitados");
    XLSX.writeFile(wb, `Reporte_Invitados_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  if (dataReport.loading) {
    return (
      <Sidebar>
        <Container className="mt-4 mb-5">
          <Row className="justify-content-center">
            <Col md="auto">
              <Spinner animation="border" variant="primary" />
              <p className="mt-2">Cargando tus reportes...</p>
            </Col>
          </Row>
        </Container>
      </Sidebar>
    );
  }

  if (dataReport.error) {
    return (
      <Sidebar>
        <Container className="mt-4 mb-5">
          <Row className="justify-content-center">
            <Col md="auto">
              <div className="alert alert-danger">
                {dataReport.error}
              </div>
              <Button variant="primary" onClick={() => reportesGetUser(users.id)}>
                Reintentar
              </Button>
            </Col>
          </Row>
        </Container>
      </Sidebar>
    );
  }

  return (
    <Sidebar>
      <Container className="mt-4 mb-5">
        <Row className="mb-4">
          <Col>
            <h3><FaChartBar className="me-2" />Mis Reportes de Referidos</h3>
            <p className="text-muted">Resumen de tu actividad en el programa de referidos</p>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={3} className="mb-3">
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="text-muted mb-2">Mis Referidos</h6>
                    <h3>{dataReport.data.totals.referidos}</h3>
                  </div>
                  <div className="bg-primary bg-opacity-10 p-3 rounded">
                    <FaUsers size={24} className="text-primary" />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3} className="mb-3">
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="text-muted mb-2">25% de Ganancias</h6>
                    <h3>${dataReport.data.totals.ganancias25.toFixed(2)}</h3>
                    <small className="text-muted">De ${dataReport.data.totals.totalVentas.toFixed(2)} en ventas</small>
                  </div>
                  <div className="bg-success bg-opacity-10 p-3 rounded">
                    <FaCoins size={24} className="text-success" />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3} className="mb-3">
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="text-muted mb-2">Compraron</h6>
                    <h3>{dataReport.data.totals.compradores}</h3>
                    <small className="text-muted">{conversion.toFixed(1)}% de conversión</small>
                  </div>
                  <div className="bg-info bg-opacity-10 p-3 rounded">
                    <FaShoppingCart size={24} className="text-info" />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3} className="mb-3">
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="text-muted mb-2">Total Ventas</h6>
                    <h3>${dataReport.data.totals.totalVentas.toFixed(2)}</h3>
                  </div>
                  <div className="bg-warning bg-opacity-10 p-3 rounded">
                    <FaChartBar size={24} className="text-warning" />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title className="mb-4">Mis Invitados</Card.Title>
                
                {dataReport.data.invitados.length > 0 ? (
                  <div className="table-responsive">
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Nombre</th>
                          <th>Email</th>
                          <th>Programa</th>
                          <th>Estado</th>
                          <th>Compras</th>
                          <th>Total Comprado</th>
                          <th>25% Ganancias</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataReport.data.invitados.map((invitado) => (
                          <tr key={invitado.id}>
                            <td>{invitado.id}</td>
                            <td>{invitado.nombre}</td>
                            <td>{invitado.email}</td>
                            <td>
                              {invitado.programa === 'CIRP' 
                                ? <span className="badge bg-primary">{invitado.programa}</span>
                                : <span className="badge bg-success">{invitado.programa}</span>}
                            </td>
                            <td>
                              <span className={`badge ${invitado.estado === 'activo' ? 'bg-success' : 'bg-secondary'}`}>
                                {invitado.estado === 'activo' ? 'Activo' : 'Inactivo'}
                              </span>
                            </td>
                            <td>
                              {invitado.haComprado ? (
                                <span className="badge bg-success">
                                  {invitado.compras.length} compra(s)
                                </span>
                              ) : (
                                <span className="badge bg-secondary">No ha comprado</span>
                              )}
                            </td>
                            <td>
                              {invitado.haComprado ? (
                                <span className="text-success fw-bold">
                                  ${invitado.totalComprado.toFixed(2)}
                                </span>
                              ) : '$0.00'}
                            </td>
                            <td>
                              {invitado.haComprado ? (
                                <span className="text-primary fw-bold">
                                  ${(invitado.totalComprado * 0.25).toFixed(2)}
                                </span>
                              ) : '$0.00'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <p>No tienes invitados registrados aún.</p>
                    <Button variant="success" size="sm">
                      Invitar contactos
                    </Button>
                  </div>
                )}

                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <Button 
                      variant="outline-primary" 
                      size="sm" 
                      onClick={exportToExcel}
                      disabled={dataReport.data.invitados.length === 0}
                    >
                      Exportar a Excel
                    </Button>
                  </div>
                  <div>
                    <Button variant="success" size="sm" onClick={() => reportesGetUser(users.id)}>
                      Actualizar datos
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Sidebar>
  );
};

export default Reportesuser;